<template>
  <div class="px-5px bg-gray-extraLight mb-5px">
    <UserCreationPanel :user="comment.user" :created="comment.created" />

    <div class="mt-10px">
      <div v-html="comment.text" v-show="!editMode" class="comment-text"></div>

      <div v-if="editMode">
        <ckeditor :editor="editor" v-model="commentText" :config="editorConfig"></ckeditor>

        <div class="mt-10px mb-10px">
          <button class="btn btn-primary btn-sm rounded-0" @click="updateComment">Uložiť</button>
          <span class="me-5px"></span>
          <button class="btn btn-secondary btn-sm rounded-0" @click="this.editMode = !this.editMode">Zrušiť</button>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between" v-if="!editMode">
        <VoteWrapper :vote-property="'fk_comment'" :vote-value="comment.id" :can-vote="comment.canVote" />

        <div class="d-flex align-items-center gap-5px">
          <Report v-if="comment.canReport" :entity-value="'text'" :entity-name="'fk_comment'" :entity-id="comment.id" />

          <div v-if="comment.canEdit">
            <button class="btn btn-link btn-sm p-0" @click="this.editMode = !this.editMode">
              Upraviť
            </button>
          </div>

          <div v-if="comment.canDelete" class="ms-10px">
            <button class="btn btn-link text-danger btn-sm p-0 lh-1" role="button" @click="this.$emit('deleteComment', comment.id)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VoteWrapper from "../Vote/VoteWrapper.vue";
import UserImage from "../User/UserImage.vue";
import UserAvatarComment from "../User/UserAvatarComment.vue";
import Report from "../Report/Report.vue";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import { commentConfig } from "../ckeditor/configs";
import { updateComment } from "../helpers/CommentApi";
import UserCreationPanel from "../User/UserCreationPanel.vue";

export default {
  name: "Comment",
  components: {UserImage, VoteWrapper, UserAvatarComment, Report, UserCreationPanel },
  emits: ['deleteComment', 'updateComment'],
  props: {
    comment: Object
  },
  data() {
    return {
      editMode: false,
      commentText: '',
      editor: ClassicEditor,
      editorConfig: commentConfig
    }
  },
  methods: {
    updateComment() {
      const data = {
        id: this.comment.id,
        text: this.commentText
      };

      updateComment(data).then(res => {
        this.comment.text = data.text;
        this.editMode = !this.editMode;
      });
    }
  },
  mounted() {
    this.commentText = this.comment.text;
  }
}
</script>
